import Image from "next/image";
import {
  AnalyticsHeader,
  faqs,
  howItWorks,
  purchaseCreditLanguages,
  purchaseGiftCardLanguages,
  redeemGiftCardLanguages,
} from "./helpers";
import { routes } from "@/global/routes";
import SeatMap3dPreview from "public/images/diamondbacks/seat_map_preview.png";
import BackgroundImage from "public/images/diamondbacks/dbacks_bg.jpeg";
import BannerImage from "public/images/diamondbacks/MK05-10251389 Web - 2026 Attend Site Specs-1486x148-ACCESS PASS.jpg";
import { TeamConfig } from "../types";
import { vendorUUIDs } from "../../constants";
import {
  DbacksTCLanguage,
  DbacksHamburgerTCListItems,
} from "../../tc_helper_dbacks";

const LogoImage = "https://ss-leagues.s3.amazonaws.com/MLB-3/AZD-UPDATED.png";

const config: TeamConfig = {
  teamSchema: "dbacks_flex",
  browserTitle: "Arizona Diamondbacks",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  mlbTeamId: 109,
  teamName: "Arizona Diamondbacks",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10167-diamondbacks-sec",
    mapId: "blockmap2d",
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: true,
    isStandAlonePurchaseCreditEnabled: true,
    showPurchaseCreditLinkInHomeMenu: true,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: true,
  isCrowdHandlerEnabled: false,
  inventoryType: "SEAT-LEVEL",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    isPerksEnabled: true,
    hideViewTicketsInThankYouPage: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  isSaveCardAllowed: true,
  oktaClientId: "",
  oktaIssuer: "",
  refreshInventoryWhenEventClick: false,
  platform: vendorUUIDs.ticketmaster,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    AnalyticsHeader: AnalyticsHeader,
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  authConfigs: {
    isLoginRequired: true,
  },

  // urls
  accountManagerUrl: "https://bp.mlb.com/Wallet",

  // images
  images: {
    findGamesBannerImage: BannerImage.src,
    authBackgroundImage: BackgroundImage.src,
    checkoutStatusPageImage: BackgroundImage.src,
    giftCardStandalonePageImage: BannerImage.src,
    logoImage: LogoImage + "?width=84&height=66",
    logoNameImage: "",
    faviconImage: LogoImage,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: true,
      hideOverlayLogo: true,
    },

    bottomBar: {
      showGameSelectionProgress: false,
    },
    checkoutPerkSubtotals: {
      perkTotalLabel: "Add-Ons Total",
    },

    purchaseHistory: {
      hideAccessTicketButton: true,
    },
    authPage: {
      showHamburgerMenuButton: true,
    },
  },

  colors: {
    primary: "#AA182C",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: <DbacksHamburgerTCListItems />, // can be react node as well
    checkoutTermsAndCondition: <DbacksTCLanguage />,
    registrationTermsAndCondition: <DbacksTCLanguage />,
    purchaseSeats: null,
    purchaseGiftCard: purchaseGiftCardLanguages,
    redeemGiftCard: redeemGiftCardLanguages,
    purchaseCredit: purchaseCreditLanguages,

    checkoutSuccessMessage: "Order Confirmed",

    checkoutServiceNote:
      "You will be notified when your tickets are available to be managed.",
    optionsMenuLoginButtonLanguage: "Get Started",

    authPage: {
      loginPage: {
        loginCard: (
          <>
            <Image
              width={1133}
              height={120}
              alt="Arizona Diamondbacks"
              src={BannerImage.src}
              style={{
                width: "100%",
                height: "100%",
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
              }}
            />
          </>
        ),
        loginCardDescription:
          "Click Get Started to continue. First-time buyers must purchase credit first.",
        loginCardButtonText: "Get Started",
      },
    },

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
